module.exports = __webpack_public_path__ + "img/legal_icon.02f85218.svg";